import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

class UsageSummary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t, classes } = this.props;

    const tmp = (
      <React.Fragment>
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item sm={12} xs={12}>
            <Typography className={classes.titleHeader}>{t('usage_summary')}</Typography>
          </Grid>
          <Grid item sm={12} xs={12}>
            <Paper className={classes.gridContent}>
              <Typography className={classes.titleHeader}>{t('receiver')}</Typography>
              <Grid container item sm={12} xs={12}>
                <Grid item sm={2} />
                <Grid item sm={2}>
                  <Link to='/app/usagesummary/router' title={t('router')} id='usagesummary-router'>
                    <div className={classes.wrapContent}>
                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <Icons.Router className={classes.styleIcon} />
                      </Grid>
                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <Typography className={classes.contentTitle}>{t('router_usage_summary')}</Typography>
                      </Grid>
                    </div>
                  </Link>
                </Grid>
              </Grid>

              <hr className={classes.divider} />
              <Typography className={classes.titleHeader}>{t('device')}</Typography>
              <Grid container item sm={12} xs={12}>
                <Grid item sm={2} />
                <Grid item sm={2}>
                  <Link to='/app/usagesummary/device' title={t('wearable_device')} id='wearable-device'>
                    <div className={classes.wrapContent}>
                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <Icons.Memory className={classes.styleIcon} />
                      </Grid>
                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <Typography className={classes.contentTitle}>{t('wearable_device')}</Typography>{' '}
                      </Grid>
                    </div>
                  </Link>
                </Grid>
                <Grid item sm={2}>
                  <Link to='/app/usagesummary/fixedbutton' title={t('fixed_button')} id='fixed-button-device'>
                    <div className={classes.wrapContent}>
                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <div className={classes.styleIcon}>
                          <svg width='35' height='35' viewBox='0 0 20 20'>
                            <use xlinkHref={`/images/sos-v4.svg#sos-device`} />
                          </svg>
                        </div>
                      </Grid>

                      <Grid item sm={12} xs={12} container justify='center' alignItems='center'>
                        <Typography className={classes.contentTitle}>{t('fixed_button')}</Typography>
                      </Grid>
                    </div>
                  </Link>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );

    return tmp;
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  titleHeader: {
    color: theme.palette.text.header,
    fontSize: '24px',
    padding: '4px',
    fontWeight: 500,
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  divider: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    margin: '10px 0px 10px 0',
    padding: 0,
    right: 8,
    width: '100%',
  },
  btncsv: {
    border: 'none',
    backgroundColor: '#E5F0F6',
    cursor: 'pointer',
    '&:hover': {
      border: 'none',
      backgroundColor: '#E5F0F6',
    },
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  wrapText: {
    display: 'flex',
    width: '520px',
  },
  wrapButton: {
    marginLeft: 18,
    marginTop: 6,
    display: 'flex',
    // justifyContent: "end",
    // alignItems: "center",
    [theme.breakpoints.down('md')]: {
      justifyContent: 'start',
      marginTop: 10,
    },
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
  },
  headTable: {
    border: 'none',
  },
  bodyTable: {
    borderTop: '1px solid #B8CFC3',
  },
  bgIcon: {
    backgroundColor: theme.palette.primary.bg,
    width: 80,
    height: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    margin: 8,
  },
  styleIcon: {
    color: theme.palette.success.main,
    width: 44,
    height: 44,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gridContent: {
    position: 'relative',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
    padding: '10px 25px',
  },
  wrapContent: {
    margin: 8,
    textAlign: 'center',
    cursor: 'pointer',
  },
  contentTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  contentSubTitle: {
    fontSize: 36,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
});

export const page = inject('device')(observer(UsageSummary));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
